module.exports = __webpack_public_path__ + "static/media/croissant-toast.c51da0de.jpeg";